var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LabelText',[_vm._v(_vm._s(_vm.label))]),_c('BaseTextarea',_vm._g({attrs:{"field-class":_vm.fieldClass,"value":_vm._value,"name":_vm.name,"placeholder":_vm.placeholder,"rows":_vm.rows,"disabled":_vm.disabled,"col":_vm.col,"empty-str-to-null":_vm.emptyStrToNull,"errors":_vm.errors}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }